import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "rsuite/dist/rsuite-no-reset.min.css";
import "./Date.css";
import {
  addFilters,
  applyFilters,
} from "../../store/slices/FilterSliceDealerReview";
import ViMultiSelect from "../Multi-Select-Dropdown/ViMultiSelectDropdownDealerReview";
import { useQuery } from "@tanstack/react-query";
import {
  fetchRegion,
  fetchStates,
  fetchStatesOffice,
  fetchDealer,
  fetchDealercode,
  fetchProductLine,
  fetchLOB,
  fetchPartnerType,
  reducer,
} from "./apiDealerReviewFilter";

//*------------------COMP----------------------*//
export default function DealerReviewFilter() {
  const { data, submitted } = useSelector((state) => state.filtersDealerReview);

  const { data: newdata } = useSelector((state) => state.forms);

  const {
    region: pRegion,
    state: pState,
    state_office: pStateOffice,
    dealer_name: pDealer,
    dealer_code: pDealerCode,
    Product_Line: pProductLine,
    lob: pLob,
    Partner_Type: pPartnerType,
  } = data;

  const dispatch = useDispatch();
  const [clicked, setClicked] = useState(1);
  const [selectedRegion, setSelectedRegion] = useState([]);
  const [selectedState, setSelectedState] = useState([]);
  const [selectedStateOffice, setSelectedStateOffice] = useState([]);
  const [selectedDealer, setSelectedDealer] = useState([]);
  const [selectedDealerCode, setSelectedDealerCode] = useState([]);
  const [selectedProductLine, setSelectedProductLine] = useState([]);
  const [selectedLob, setSelectedLOB] = useState([]);
  const [selectedPartnerType, setSelectedPartnerType] = useState([]);

  //* ---------------USE QUERY---------------------/

  const { data: regions, isLoading: rL } = useQuery({
    queryKey: ["DealerReview", "region", submitted],
    queryFn: () => fetchRegion(),
    initialData: [],
  });

  const { data: states, isLoading: sL } = useQuery({
    queryKey: ["DealerReview", "states", submitted, pRegion],
    queryFn: () => fetchStates(pRegion),
    initialData: [],
  });

  const { data: statesoffice, isLoading: soL } = useQuery({
    queryKey: ["DealerReview", "statesoffice", submitted, pRegion, pState],
    queryFn: () => fetchStatesOffice(pRegion, pState),
    initialData: [],
  });

  // console.log(statesoffice);
  const { data: PartnerType, isLoading: poL } = useQuery({
    queryKey: [
      "DealerReview",
      "PartnerType",
      submitted,
      pRegion,
      pState,
      pStateOffice,
    ],
    queryFn: () => fetchPartnerType(pRegion, pState, pStateOffice),
    initialData: [],
  });

  const { data: dealer, isLoading: dL } = useQuery({
    queryKey: [
      "DealerReview",
      "dealer",
      submitted,
      pRegion,
      pState,
      pStateOffice,
      pPartnerType,
    ],
    queryFn: () => fetchDealer(pRegion, pState, pStateOffice, pPartnerType),
    initialData: [],
  });

  const { data: dealercode, isLoading: dcL } = useQuery({
    queryKey: [
      "DealerReview",
      "dealercode",
      submitted,
      pRegion,
      pState,
      pStateOffice,
      pPartnerType,
      pDealer,
    ],
    queryFn: () =>
      fetchDealercode(pRegion, pState, pStateOffice, pPartnerType, pDealer),
    initialData: [],
  });

  const { data: productLine, isLoading: plL } = useQuery({
    queryKey: [
      "DealerReview",
      "productLine",
      submitted,
      pRegion,
      pState,
      pStateOffice,
      pPartnerType,
      pDealer,
      pDealerCode,
    ],
    queryFn: () =>
      fetchProductLine(
        pRegion,
        pState,
        pStateOffice,
        pPartnerType,
        pDealer,
        pDealerCode
      ),
    initialData: [],
  });

  const { data: lob, isLoading: lobL } = useQuery({
    queryKey: [
      "DealerReview",
      "lob",
      submitted,
      pRegion,
      pState,
      pStateOffice,
      pPartnerType,
      pDealer,
      pDealerCode,
      pProductLine,
    ],
    queryFn: () =>
      fetchLOB(
        pRegion,
        pState,
        pStateOffice,
        pPartnerType,
        pDealer,
        pDealerCode,
        pProductLine
      ),
    initialData: [],
  });

  //* ---------------HANDLE EVENTS---------------------/
  async function handleSearch() {
    let userSelectedFilter = {
      data: {
        region: pRegion || selectedRegion,
        state: pState || selectedState,
        state_office: pStateOffice || selectedStateOffice,
        Partner_Type: pPartnerType || selectedPartnerType,
        dealer_name: pDealer || selectedDealer,
        dealer_code: pDealerCode || selectedDealerCode,
        Product_Line: pProductLine || selectedProductLine,
        lob: pLob || selectedLob,
      },
      submitted: clicked + 1,
    };

    dispatch(addFilters(userSelectedFilter));
    setClicked((prev) => prev + 1);
  }

  const handleRefresh = () => {
    window.location.reload();
  };

  // const toggleForm = () => {
  //   setFormVisible(!isFormVisible);
  // };

  //*----------------------JSX-------------------------/
  return (
    <section className="">
      <div className="border-[#2c8a8b] border rounded-md  grid grid-cols-2 gap-2 p-2 md:gap-2 lg:grid-cols-[repeat(9,minmax(0,1fr))] md:grid-cols-4">
        <div className={divStyle}>
          <label className={labelStyle}>Region</label>
          <ViMultiSelect
            options={regions}
            onSelectionChange={setSelectedRegion}
            opnsSelected={pRegion}
            keey="region"
            isLoading={rL}
          />
        </div>

        <div className={divStyle}>
          <label className={labelStyle}>State</label>
          <ViMultiSelect
            options={states}
            onSelectionChange={setSelectedState}
            opnsSelected={pState}
            keey="state"
            isLoading={sL}
          />
        </div>

        <div className={divStyle}>
          <label className={labelStyle}>State Office</label>
          <ViMultiSelect
            options={statesoffice}
            onSelectionChange={setSelectedStateOffice}
            opnsSelected={pStateOffice}
            keey="state_office"
            isLoading={soL}
          />
        </div>
        <div className={divStyle}>
          <label className={labelStyle}>Partner Type</label>
          <ViMultiSelect
            options={PartnerType}
            onSelectionChange={setSelectedPartnerType}
            opnsSelected={pPartnerType}
            keey="Partner_Type"
            isLoading={poL}
          />
        </div>

        <div className={divStyle}>
          <label className={labelStyle}>Dealer Name</label>
          <ViMultiSelect
            options={dealer}
            onSelectionChange={setSelectedDealer}
            opnsSelected={pDealer}
            keey="dealer_name"
            isLoading={dL}
          />
        </div>

        <div className={divStyle}>
          <label className={labelStyle}>Dealer Code</label>
          <ViMultiSelect
            options={dealercode}
            onSelectionChange={setSelectedDealerCode}
            opnsSelected={pDealerCode}
            keey="dealer_code"
            isLoading={dcL}
          />
        </div>

        <div className={divStyle}>
          <label className={labelStyle}>Product Line</label>
          <ViMultiSelect
            options={productLine}
            onSelectionChange={setSelectedProductLine}
            opnsSelected={pProductLine}
            keey="Product_Line"
            isLoading={plL}
          />
        </div>

        <div className={divStyle}>
          <label className={labelStyle}>LOB</label>
          <ViMultiSelect
            options={lob}
            onSelectionChange={setSelectedLOB}
            opnsSelected={pLob}
            keey="lob"
            isLoading={lobL}
          />
        </div>
        <div className="grid grid-cols-2 gap-2 w-full md:grid-cols-1">
          <div>
            <button
              className="text-white w-full rounded-sm bg-[#2A5775]"
              type="button"
              onClick={handleSearch}
            >
              Apply
            </button>
          </div>
          <div>
            <button
              className="text-white w-full rounded-sm bg-[#2A5775]"
              onClick={handleRefresh}
            >
              Reset
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

//*------------------CSS----------------------*//
const divStyle = "flex flex-col justify-center";
const labelStyle =
  "font-semibold py-1 text-xs text-[#2A5775] whitespace-nowrap ";
